import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconClockCog } from "@tabler/icons-react";
import { RutasTiendasConfiguracionTiempoDef } from "./RutasTiendasConfiguracionTiempoDef";

export const RutasTiendasConfiguracionTiempoIcon = IconClockCog;
export const RutasTiendasConfiguracionTiempoHelpText = '* Configuración del tiempo en tienda. Esta configuración será utilizada para determinar si las rutas asignadas a un Tienda cumplen con la configuración de tiempo pactado con los clientes.';

export class RutasTiendasConfiguracionTiempo extends Entity<RutasTiendasConfiguracionTiempoDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RutasTiendasConfiguracionTiempoDef(), parentKeys);
        this.Form = import('./RutasTiendasConfiguracionTiempoForm').then((module) => module.RutasTiendasConfiguracionTiempoForm);
        this.Title = "Configuración de Tiempo en Tienda";
        this.HelpText = RutasTiendasConfiguracionTiempoHelpText;
        this.Icon = RutasTiendasConfiguracionTiempoIcon;
    }

}